import { render, staticRenderFns } from "./AdminNotification.vue?vue&type=template&id=584010b2&scoped=true"
import script from "./AdminNotification.vue?vue&type=script&lang=js"
export * from "./AdminNotification.vue?vue&type=script&lang=js"
import style0 from "./AdminNotification.vue?vue&type=style&index=0&id=584010b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584010b2",
  null
  
)

export default component.exports